var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 22.202L7 30l7-7.798-1.418-1.362-4.615 5.137V0H6.033v25.979L1.417 20.84 0 22.202z",
    fill: "#7C02BB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAxNCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDIyLjIwMjRMNyAzMEwxNCAyMi4yMDI0TDEyLjU4MTUgMjAuODQwMUw3Ljk2NzA0IDI1Ljk3NzFMNy45Njc3NyAwTDYuMDMyMjMgMEw2LjAzMTQ5IDI1Ljk3OUwxLjQxODQ2IDIwLjg0MDFMMCAyMi4yMDI0WiIgZmlsbD0iIzdDMDJCQiIvPgo8L3N2Zz4K";
export { SvgArrowDownPurple as ReactComponent };